import { categories } from '@/mocks/gossip';

export default function Footer() {
  return (
    <footer className="mt-4 bg-primary-800">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-background-50/10 text-lg text-accent-300">
                <i className="ri-focus-3-line" />
              </span>
              <span className="font-heading text-xl font-bold tracking-tight text-background-50">
                吃瓜<span className="text-accent-400">大全</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300/80">
              吃瓜大全热门事件合集，每日更新今日汇总与最新瓜料，热点事件打包整理，一站在手吃瓜不愁。让每一次“吃瓜”都有条理、有温度。
            </p>
            <div className="mt-5 flex items-center gap-2 text-background-400">
              <i className="ri-mail-line" />
              <span className="text-sm">contact@chiguadaquan.example</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">热门栏目</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(1).map((c) => (
                <li key={c.key}>
                  <a
                    href="#feed"
                    className="inline-flex items-center gap-2 text-sm text-background-300/80 transition-colors hover:text-accent-300"
                  >
                    <i className={`${c.icon} text-base`} />
                    {c.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">快速入口</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { id: 'timeline', label: '今日汇总' },
                { id: 'feed', label: '热门瓜料' },
                { id: 'featured', label: '深度专题' },
                { id: 'principles', label: '吃瓜守则' },
                { id: 'faq', label: '常见问题' },
                { id: 'about', label: '关于我们' },
              ].map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    className="inline-block text-sm text-background-300/80 transition-colors hover:text-accent-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-700/60 pt-6 text-xs text-background-400/80 sm:flex-row">
          <p>© 2026 吃瓜大全 · 热门事件合集，让热闹更有条理。</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line" />
            理性吃瓜 · 文明冲浪
          </p>
        </div>
      </div>
    </footer>
  );
}